var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 2.16406V6.16406M8.33203 2.16406V6.16406",
    stroke: "#0BA6C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 4.16406H11.332C7.56079 4.16406 5.67518 4.16406 4.5036 5.33563C3.33203 6.50721 3.33203 8.39282 3.33203 12.1641V14.1641C3.33203 17.9353 3.33203 19.821 4.5036 20.9925C5.67518 22.1641 7.56079 22.1641 11.332 22.1641H13.332C17.1032 22.1641 18.9889 22.1641 20.1604 20.9925C21.332 19.821 21.332 17.9353 21.332 14.1641V12.1641C21.332 8.39282 21.332 6.50721 20.1604 5.33563C18.9889 4.16406 17.1032 4.16406 13.332 4.16406Z",
    stroke: "#0BA6C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10.1641H21.332",
    stroke: "#0BA6C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 14.1641H16.332M8.33203 14.1641H8.34101M13.332 18.1641H8.33203M16.332 18.1641H16.323",
    stroke: "#0BA6C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionIcon);
export default __webpack_public_path__ + "static/media/selection-icon.f64462136deb4a93f2c126bd05b8199f.svg";
export { ForwardRef as ReactComponent };